import Api from '@/services/Api';

export default {
  getList() {
    return Api().get('/lines');
  },
  getListLength() {
    return Api().get('/lines/length');
  },
  getListAverageChild() {
    return Api().get('/lines/kids/average');
  },
  getListActive() {
    return Api().get('/lines/active');
  },
  getListDead() {
    return Api().get('/lines/inactive');
  },
  getListByMonthAndYear(params: any) {
    if (params && params.month && !params.year) {
      return Api().get(`/lines?month=${params.month}`);
    } if (params && !params.month && params.year) {
      return Api().get(`/lines?year=${params.year}`);
    }
    return Api().get(`/lines?month=${params.month}&year=${params.year}`);
  },
  getListByMonthAndYearLength(params: any) {
    if (params && params.month && !params.year) {
      return Api().get(`/lines/length?month=${params.month}`);
    } if (params && !params.month && params.year) {
      return Api().get(`/lines/length?year=${params.year}`);
    }
    return Api().get(`/lines/length?month=${params.month}&year=${params.year}`);
  },
  getListByBranche(params: any) {
    return Api().get(`/lines?branch=${params.branche.id}`);
  },
  getListByBrancheLength(params: any) {
    return Api().get(`/lines/length?branch=${params.branche.id}`);
  },
  getListByState(params: any) {
    return Api().get(`/lines?state=${params.state}`);
  },
  getListByStateLength(params: any) {
    return Api().get(`/lines/length?state=${params.state}`);
  },
  getListReferenced() {
    return Api().get('/lines/referenced');
  },
  getListReferencedLength() {
    return Api().get('/lines/referenced/length');
  },
  getListReferencedByBranche(params: any) {
    return Api().get(`/lines/referenced?branch=${params.branche.id}`);
  },
  getListReferencedByBrancheLength(params: any) {
    return Api().get(`/lines/referenced/length?branch=${params.branche.id}`);
  },
  getChildrenForLine(params: any) {
    return Api().get(`lines/${params.id_pedibus}/kids/length`);
  },
};
